const en = {
	language: {
		cn: 'CN',
		en: 'EN',
	},
	index: {
		about: {
			title: 'About us',
			txt1: 'company profile',
			txt2: 'company profilecompany profilecompany profilecompany profile',
			txt3: 'company profilecompany profilecompany profilecompany profile',
			txt4: 'company profilecompany'
		},
		huanjing: {
			title: 'Company environment'
		},
		chart: {
			txt: 'captionscaptionscaptionscaptionscaptionscaptionscaptions'
		},
		rongyu: {
			title: 'Honorary certificate'
		},
		product: {
			title: 'Our products'
		},
		pinpai: {
			title: 'Cooperation brand'
		},
		link: {
			title: 'Link'
		}
	},
	//新闻资讯
	exhibition: {
		content: 'News and information'
	},
	//联系我们
	contact: {
		successText: 'Submitted successfully',
		lxwm: 'lxwm',
		xszx: 'xszx',
		lxfs: 'lxfs',
		name: 'name',
		nameText: 'nameText',
		phone: 'phone',
		phoneText: 'phoneText',
		email: 'email',
		emailText: 'emailText',
		yjyjy: 'yjyjy',
		yjyjyText: 'yjyjyText',
		reset: 'reset',
		submit: 'submit',
		gsmc: 'gsmc',
		lxfs: 'lxfs',
		gsdz: 'gsdz',
		zipcode: 'zipcode',
		mapAddress: 'mapAddress',
		mapAddressText: 'mapAddressText',
		mapPhone: 'mapPhone',
		mapPhoneNum: '18888888888',
		mapGsmc: 'mapGsmc',
	},
	//版权信息
	footer: {
		cpdw: 'Production unit',
		sccj: 'The manufacturer',
		address: 'Address',
		lxfs: 'Contact us',
		zipcode: 'zipcode',
	},
	//地图
	chart: {
		title: 'XXXXXNetwork sales map',
		city: {
			bjs: 'beijing',
			tjs: 'tianjin',
			zzs: 'zhuozhou',
			bds: 'baoding',
			wfs: 'weifang',
			jns: 'jining',
			hzs: 'hangzhou',
			nbs: 'ningbo',
			suzhoushi: 'suzhou',
			czs: 'changzhou',
			wxs: 'wuxi',
			jys: 'jiangyin',
			wzs: 'wenzhou',
			tzs: 'taizhou',
			njs: 'nanjing',
			ncs: 'nanchang',
			shs: 'shanghai',
			gzs: 'guangzhou',
			shenzhenshi: 'shenzhen',
			zhs: 'zhuhai',
			fss: 'foshan',
			nns: 'nanning',
			gls: 'guilin',
			hks: 'haikou',
			sys: 'sanya',
		}
	}
};

export default en